import React from "react"
import { useOutletContext, useNavigate, useParams } from "react-router-dom";

import { useProfile } from "../../common/useProfile";
import Service from "../../../util/Service";
import { CircularProgress, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Popover, Stack, Tooltip, Typography } from "@mui/material";
import HtmlContent from "../../util/HtmlContent";
import EditIcon from '@mui/icons-material/Edit';
import VeryEditor2 from "../../common/EditorVery/VeryEditor2";
import { DisplaySettings, Download, ExitToApp, ImportExport, More, MoreHoriz, Save, Upload } from "@mui/icons-material";
import EditarPortalExportComp from "../portal/EditarPortalExportComp";
import MenuBackupPage from "../portal/comps/MenuBackupPage";
import EditarPortalSetting from "../portal/EditarPortalSetting";
import EditarDescricaoPaginaDialog from "./EditarDescricaoPaginaDialog";

export default function EditarPaginaPanel() {
    const prof = useProfile();
    const params = useParams();
    const refDiv = React.useRef();
    const ref = React.useRef();
    const [pagina, setPagina] = React.useState();
    const [wait, setWait] = React.useState(true);
    const [edit, setEdit] = React.useState(true);

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;


    React.useEffect(() => {
        const id = params.id;
        buscaPagina(id);
    }, [prof.profile]);

    function buscaPagina(p) {
        setWait(true);
        Service.GET("/api/paginaHtml/buscaPorId/" + p).then(r => {
            setPagina(r);
            setWait(false);
        })
    }
    function handleDownload(){
        const html = ref.current.getHtml();

        const nome = pagina.nome;
        const blob = new Blob([html], { type: 'application/txt' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = nome+'.html'; // Set the desired file name
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }
    const handleUpload=(e)=>{
        const file = document.getElementById("fileCode");
        file.click();
    }
    const upload = () => {
        let input = document.getElementById("fileCode");
        const file = input.files[0];
        if (file) {        
            if (file.type !== "text/html") {
                alert("Aceita apenas arquivos javascript (.html)");
                input.value = ''; // Clear the input to allow re-selection
                return;
            }
            const fileReader = new FileReader();
            fileReader.onload = event => {
                // setCode(event.target.result)
                const item = {...pagina};
                item.pagina = event.target.result
                setPagina( item);
                input.value = '';
            }            
            fileReader.readAsText(file);
        }
    }

    function handleSalva() {
        const html = ref.current.getHtml();

        let dado = {
            id: pagina.id,
            pagina: html,
        }

        Service.POST("/api/security/paginaHtml/html", dado).then(r => {
            const p ={...pagina};
            p.pagina = html
            setPagina( p );
        })
    }
    function handleEdit() {
        console.log('>>>handleEdit<<', edit);
        setEdit(true);
    }

    if (wait) {
        return (
            <center style={{ marginTop: '10%' }}>
                <CircularProgress color="inherit" />
            </center>
        )
    }
    if (!pagina) {
        return (
            <div style={{ padding: '5px', marginTop: '15px' }}>
                <Typography variant="h4">Voce pode criar sua pagina personalisando editando o componente abaixo:</Typography>

                <VeryEditor2
                    html={pagina ? pagina.pagina : ''} ref={ref}
                    style={{ padding: 4, border: '2px solid black', overflow: 'auto', height: '450px' }}
                    action={
                        <React.Fragment>
                            <Tooltip title="Salvar pagina">
                                <IconButton aria-label="edit" color="primary"
                                    onClick={handleSalva}
                                >
                                    <Save />
                                </IconButton>
                            </Tooltip>
                        </React.Fragment>
                    }
                    saveAction={handleSalva}
                />
            </div>
        )
    }
    if (edit === true) {
        return (
            <div style={{ padding: '5px' }}>
                <div className='edit'>
                    {/* <Tooltip title="Sair da edição" >
                        <IconButton aria-label="edit" color="primary"
                            onClick={() => setEdit(false)}
                        >
                            <ExitToApp />
                        </IconButton>
                    </Tooltip> */}
                    <Tooltip title="Upload">
                        <IconButton aria-label="edit" color="primary"
                            onClick={handleUpload}
                        >
                            <Upload />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Download">
                        <IconButton aria-label="edit" color="primary"
                            onClick={handleDownload}
                        >
                            <Download />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Mais Opções">
                        <IconButton aria-label="edit" color="primary"
                            onClick={handleClick}
                        >
                            <MoreHoriz />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Salvar pagina">
                        <IconButton aria-label="edit" color="primary"
                            onClick={handleSalva}
                        >
                            <Save />
                        </IconButton>
                    </Tooltip>
                </div>
                <VeryEditor2
                    html={pagina.pagina}
                    ref={ref}
                    style={{
                        padding: 4, border: '2px solid black', overflow: 'auto',
                        maxHeight: '90vh',
                        height: "70vh"
                    }}
                    saveAction={handleSalva}
                />

                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                >
                    <Stack>
                        <Tooltip title="Sair da edição" placement="left-start">
                            <IconButton aria-label="edit" 
                                // color="primary"
                                onClick={() => {
                                    setEdit(false);
                                    handleClose();
                                }}
                            >
                                <ExitToApp />
                            </IconButton>
                        </Tooltip>
                        {/* <Tooltip title="Abrir Descrição" placement="left-start">
                            <IconButton aria-label="edit" 
                                // color="primary"
                                onClick={() => {
                                    setEdit(false);
                                    handleClose();
                                }}
                            >
                                <DisplaySettings />
                            </IconButton>
                        </Tooltip> */}
                        
                        <EditarDescricaoPaginaDialog pagina={pagina} setPagina={setPagina} placement="left-start" close={handleClose}/>
                        <EditarPortalSetting pagina={pagina} placement="left-start"/>
                        <EditarPortalExportComp pagina={pagina} placement="left-start"/>
                        <MenuBackupPage pagina={pagina} action={handleClose} placement="left-start"/>
                       
                    </Stack>
                    {/* <List>
                        <ListItem disablePadding>
                            <ListItemButton>
                                <ListItemIcon>
                                    <ExitToApp />
                                </ListItemIcon>
                                <ListItemText primary="Sair da Edição" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton>
                                <ListItemIcon>
                                    <ImportExport />
                                </ListItemIcon>
                                <ListItemText primary="Drafts" />
                            </ListItemButton>
                        </ListItem>
                    </List> */}
                </Popover>
                <input type="file" id="fileCode" style={{ display: 'none' }} onChange={upload} accept=".html, text/plain"/>
            </div>
        )
    }
    return (
        <div>
            <div className='edit'>
                <Tooltip title={"Editar componente"}>
                    <IconButton aria-label="edit" color="primary" onClick={handleEdit}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <HtmlContent htmlString={pagina.pagina} edit={false} />
        </div>
    )
}